import { storyblokEditable } from "gatsby-source-storyblok"

import ProductCard from "../../../../V2/Cards/Product/index"

import {
  isConsolidatedPurchasableItem,
  parseConsolidatedPrice,
  useGetConsolidatedItem,
} from "@hooks/V2/storyblok/useConsolidatedItem"
import { getSavingsBadge } from "@utils/shop"
import React from "react"

const StoryblokProductCard = ({
  blok,
  mobileGridOrder,
  isSliderChild,
  siblingCount,
}: Storyblok.BlokProps<Storyblok.ProductCard>) => {
  const getConsolidatedItem = useGetConsolidatedItem()

  const consolidatedItem = getConsolidatedItem(blok.productConfig)

  if (!isConsolidatedPurchasableItem(consolidatedItem)) {
    return null
  }

  const productConfig = blok.productConfig.content
  const productImage = consolidatedItem.thumbnail

  const priceValue = parseConsolidatedPrice(consolidatedItem.price)
  const originalPriceValue = parseConsolidatedPrice(
    consolidatedItem.originalPrice
  )

  const effectiveBadge = priceValue
    ? getSavingsBadge(priceValue, originalPriceValue)
    : consolidatedItem.badge

  return (
    <ProductCard
      mobileGridOrder={mobileGridOrder}
      productName={consolidatedItem.name}
      shortDescription={consolidatedItem.shortDescription}
      imageUrl={productImage?.filename ?? ""}
      imageAlt={productImage?.alt || `${consolidatedItem.name}-image`}
      thumbnailVideoUrl={productConfig.thumbnailVideo?.filename}
      priceAdornmentText="R"
      priceValue={priceValue}
      ctaText={consolidatedItem.ctaText}
      ctaLink={consolidatedItem.ctaLink}
      learnMoreButtonUrl={
        blok.showLearnMoreCTA ? consolidatedItem.detailsLink : undefined
      }
      backgroundColor={blok.backgroundColor}
      isSliderChild={isSliderChild}
      hidePrice={productConfig.notAvailableForPurchase}
      siblingCount={siblingCount}
      hasBorder={blok.hasBorder ?? true}
      wasPrice={consolidatedItem.onPromotion ? originalPriceValue : undefined}
      showNumberControls={blok.showNumberControls}
      purchasableItem={consolidatedItem}
      reviewSkus={consolidatedItem.reviewSkus}
      showRating={blok.showRating}
      badge={effectiveBadge ?? undefined}
      // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokProductCard
